import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=0632fd76&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=ts&"
export * from "./SearchResults.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=0632fd76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632fd76",
  null
  
)

export default component.exports